import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['step', 'next', 'previous', 'submit']
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.updateVisibility()
  }

  next() {
    if (!this.validateCurrentStep()) return

    if (this.indexValue < this.stepTargets.length - 1) {
      this.indexValue += 1
    }
  }

  previous() {
    if (this.indexValue > 0) {
      this.indexValue -= 1
    }
  }

  goTo(event) {
    const index = parseInt(event.params.index, 10)
    if (index >= 0 && index < this.stepTargets.length) {
      if (index > this.indexValue && !this.validateCurrentStep()) return
      this.indexValue = index
    }
  }

  indexValueChanged(value, previousValue) {
    this.updateVisibility()
    this.dispatch('changed', { detail: { index: value, previousIndex: previousValue } })
  }

  // private

  updateVisibility() {
    const lastIndex = this.stepTargets.length - 1

    this.stepTargets.forEach((step, i) => {
      step.hidden = i !== this.indexValue
    })

    if (this.hasNextTarget) {
      this.nextTargets.forEach(btn => {
        btn.hidden = this.indexValue >= lastIndex
      })
    }
    if (this.hasPreviousTarget) {
      this.previousTargets.forEach(btn => {
        btn.hidden = this.indexValue <= 0
      })
    }
    if (this.hasSubmitTarget) {
      this.submitTargets.forEach(btn => {
        btn.hidden = this.indexValue < lastIndex
      })
    }
  }

  validateCurrentStep() {
    const currentStep = this.stepTargets[this.indexValue]
    if (!currentStep) return true

    const fields = currentStep.querySelectorAll('input, select, textarea')
    for (const field of fields) {
      if (field.disabled || field.hidden) continue
      if (!field.reportValidity()) return false
    }
    return true
  }
}
